import React from 'react'
import type { Icon } from 'shared/utils'

const Info = (props: Icon) => {
    const {
        size = 24,
        className = 'info',
        color = 'white',
        ...otherProps
    } = props
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            {...otherProps}>
            <g clipPath="url(#clip0_16198_135874)">
                <path
                    d="M12.2064 2.62085C7.19525 2.62085 2.86565 6.52325 2.91845 11.5296C2.94245 13.5984 3.79685 15.7776 5.23205 17.4816C5.31845 17.5824 5.08805 21.552 5.42885 21.8112C5.69285 22.0128 8.23205 19.8432 8.34725 19.9008C9.45125 20.4096 10.68 20.6784 12 20.6208C17.0064 20.6208 21.0864 16.5456 21.0864 11.5344C21.0864 6.52325 17.2128 2.62085 12.2064 2.62085ZM12.0048 18.4465C10.5648 18.4465 9.47045 18.1872 8.45285 17.6112C8.21285 17.4768 7.03685 19.224 6.82085 19.0609C6.60485 18.8976 7.11845 16.6512 6.92645 16.464C5.64965 15.2256 4.99685 13.5745 4.77125 11.616C4.33925 7.82405 8.18885 4.60805 12.0048 4.60805C15.8688 4.33445 19.0656 6.87365 18.9216 11.5248C18.8016 15.336 15.8208 18.4416 12.0048 18.4416V18.4465Z"
                    fill={color}
                />
                <path
                    d="M10.6367 11.4576C10.5599 10.6032 10.2479 9.48484 9.88313 8.38084C9.85913 8.30404 9.84473 8.21284 9.84473 8.14564C9.84473 7.40644 10.7519 6.95044 11.9999 6.95044C13.2479 6.95044 14.1551 7.41604 14.1551 8.14564C14.1551 8.22244 14.1407 8.29924 14.1167 8.38084C13.7519 9.48484 13.4399 10.5984 13.3631 11.4576C13.2719 12.4464 12.8063 12.7824 12.0527 12.7824H11.9375C11.1983 12.7824 10.7327 12.4464 10.6415 11.4576H10.6367ZM10.2479 14.9088C10.2479 14.0928 10.8815 13.416 11.9999 13.416C13.1183 13.416 13.7519 14.0928 13.7519 14.9088C13.7519 15.7248 13.1135 16.4016 11.9999 16.4016C10.8863 16.4016 10.2479 15.7248 10.2479 14.9088Z"
                    fill={color || '#FF8732'}
                />
            </g>
            <defs>
                <clipPath id="clip0_16198_135874">
                    <rect width={24} height={24} fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}

export { Info }
